import Navbar from "./Navbar";

function AboutMe() {
  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-gradient-to-br from-amber-50 via-orange-100 to-red-100">
        {/* Header Section */}
        <div className="bg-gradient-to-r from-amber-100 to-orange-100 shadow-2xl border-b-4 border-red-200">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-16">
            <div className="text-center">
              <div className="flex flex-col sm:flex-row items-center justify-center mb-6 sm:mb-8">
                <div className="relative">
                  <div className="absolute -inset-4 bg-gradient-to-r from-red-500 to-orange-500 rounded-full blur-lg opacity-30 animate-pulse"></div>
                  <img
                    src="/kevin-with-kitten.jpg"
                    alt="Kevin Hwangpo with his kitten, creator of Korlish"
                    className="h-32 w-32 sm:h-48 sm:w-48 rounded-full shadow-2xl ring-4 ring-white relative z-10 object-cover"
                  />
                  <div className="absolute -top-2 -right-2 bg-red-600 text-white text-sm font-bold px-3 py-1 rounded-full animate-bounce">
                    🇰🇷
                  </div>
                </div>
                <div className="sm:ml-8 mt-4 sm:mt-0">
                  <h1 className="text-3xl sm:text-5xl font-black text-gray-900 mb-2">Meet the Creator</h1>
                  <p className="text-lg sm:text-2xl text-red-700 font-black">창작자를 만나보세요</p>
                  <p className="text-sm sm:text-lg text-gray-600 font-semibold">(Meet the Creator)</p>
                </div>
              </div>
              
              {/* "Hi there!" text moved here */}
              <div className="mt-6 sm:mt-8">
                <p className="text-lg sm:text-2xl text-gray-900 leading-relaxed px-4">
                  <span className="text-lg sm:text-2xl text-gray-900">Hi there!</span> I'm <span className="text-orange-600 font-semibold">Kevin Hwangpo</span>—a Korean American from Virginia, currently
                  majoring in Computer Science with a minor in Artificial
                  Intelligence. I'm also the creator of Korlish.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          {/* Main Story Section */}
          <div className="bg-gradient-to-br from-red-50 to-orange-50 rounded-3xl shadow-2xl p-12 border-4 border-red-200 mb-12">
            <div className="prose prose-lg max-w-none">
              <p className="text-xl text-gray-800 leading-relaxed font-medium mb-6">
                At the time of writing, I'm honored to be a recipient of the <strong className="text-red-600">Benjamin A. Gilman International Scholarship</strong> and currently studying abroad at <strong className="text-red-600">Yonsei University</strong> in Seoul, South Korea. This opportunity not only deepened my connection to my cultural roots but also inspired the creation of Korlish as part of my Follow-on Service Project to raise awareness about studying abroad.
              </p>
              
              <p className="text-xl text-gray-800 leading-relaxed font-medium mb-6">
                Although I was fluent in Korean as a toddler, growing up in a place with few Korean speakers led me to gradually drift from my heritage. Over time, I hesitated to speak, stumbled through Hangul, and second guessed words that once came naturally.
              </p>
              
              <p className="text-xl text-gray-800 leading-relaxed font-medium mb-6">
                That's where Korlish comes in—a bridge between Korean and English learning. Using my technical background, I wanted to create an accessible, welcoming space for others to explore Hangul, build vocabulary, and gain confidence.
              </p>
              
              <p className="text-xl text-gray-800 leading-relaxed font-medium mb-6">
                Korlish is both a personal and practical project. It's my way of turning a personal challenge into a meaningful resource—for those who share a similar journey of reconnecting with culture, or simply wish to begin learning Korean in a way that feels modern, simple, and motivating.
              </p>
              
              <p className="text-xl text-gray-800 leading-relaxed font-medium">
                Whether you're reconnecting with your roots or learning Korean for the first time, I hope Korlish helps you build a strong foundation and discover confidence and connection through language.
              </p>
            </div>
          </div>

          {/* Contact & Connect Section */}
          <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-3xl shadow-xl p-12 border-4 border-orange-200 text-center">
            <div className="text-6xl mb-6">🤝</div>
            <h2 className="text-4xl font-black text-gray-900 mb-6">Let's Connect!</h2>
            <p className="text-2xl text-red-700 font-black mb-2">함께 한국어를 배워요!</p>
            <p className="text-lg text-gray-600 font-semibold mb-8">(Let's learn Korean together!)</p>
            
            <p className="text-xl text-gray-700 font-semibold mb-8">
              Have questions about Korean learning or want to share your journey? I'd love to hear from you!
            </p>
            
            <div className="flex justify-center gap-6 mb-8">
              <a
                href="https://linkedin.com/in/kevinhwangpo"
                target="_blank"
                rel="noopener noreferrer"
                className="group bg-gradient-to-r from-blue-600 to-blue-700 text-white px-8 py-4 rounded-2xl font-bold hover:from-blue-700 hover:to-blue-800 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105 flex items-center"
              >
                <svg className="w-6 h-6 mr-3" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
                LinkedIn
              </a>
              
              <a
                href="https://github.com/kevinhwangpo"
                target="_blank"
                rel="noopener noreferrer"
                className="group bg-gradient-to-r from-gray-800 to-gray-900 text-white px-8 py-4 rounded-2xl font-bold hover:from-gray-900 hover:to-black transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105 flex items-center"
              >
                <svg className="w-6 h-6 mr-3" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                </svg>
                GitHub
              </a>
            </div>
            
            <div className="flex items-center justify-center text-gray-600">
              <span className="text-2xl mr-2">💬</span>
              <p className="text-lg font-semibold">Questions? Feedback? Just want to chat about Korean?</p>
            </div>
          </div>
        </div>

        {/* Footer */}
        <footer className="bg-gradient-to-r from-red-600 via-orange-600 to-amber-600 text-white py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <div className="flex items-center justify-center mb-6">
              <img
                src="/korlish.png"
                alt="Korlish Logo"
                className="h-16 w-16 rounded-full shadow-2xl ring-4 ring-white mr-4"
              />
              <div>
                <h3 className="text-3xl font-black">Korlish</h3>
                <p className="text-lg font-semibold">한국어 학습</p>
              </div>
            </div>
            <p className="text-xl font-semibold mb-4">
              Made with 💻, 💖, and a passion for language learning
            </p>
            <p className="text-lg font-medium">
              © 2025 Korlish. Built with React, Firebase, and lots of Korean enthusiasm! 🇰🇷
            </p>
          </div>
        </footer>
      </div>
    </>
  );
}

export default AboutMe;